export const videos360 = [
    {
        "id":48,
        "contents":25,
        "name": {
            "en": "360 Documentaries",
            "be": "360 Documentaries",
            "id": "360 Documentaries",
            "it": "360 Documentaries",
            "se": "360 Documentaries",
            "no": "360 Documentaries",
            "fr": "360 Documentaries",
            "ee": "360 Documentaries"
        },
        "videos": [
            {
                "id": 986,
                "name": "Environmental film on the effects of toxins on marine life in Florida, USA",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Environmental+film+on+the+effects+of+toxins+on+marine+life+in+Florida%2C+USA.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Environmental+film+on+the+effects+of+toxins+on+marine+life+in+Florida%2C+USA.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 987,
                "name": "Bungee Jump",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Bungee+Jump.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Bungee+Jump.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 988,
                "name": "Narrated film about the Total Solar Eclipse on Svalbard, Norway, Europe",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Narrated+film+about+the+Total+Solar+Eclipse+on+Svalbard%2C+Norway%2C+Europe.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Narrated+film+about+the+Total+Solar+Eclipse+on+Svalbard%2C+Norway%2C+Europe.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 989,
                "name": "Documentary Short Film about the Meeting of Waters, Amazon River, Brasil, South America",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Documentary+Short+Film+about+the+Meeting+of+Waters%2C+Amazon+River%2C+Brasil%2C+South+America.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Documentary+Short+Film+about+the+Meeting+of+Waters%2C+Amazon+River%2C+Brasil%2C+South+America.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 990,
                "name": "Documentary about the Croocked Forest, Poland, Easter, Europe",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Documentary+about+the+Croocked+Forest%2C+Poland%2C+Easter%2C+Europe.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Documentary+about+the+Croocked+Forest%2C+Poland%2C+Easter%2C+Europe.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 991,
                "name": "Informative tour around Morgan Library, NYC, USA, North America",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Informative+tour+around+Morgan+Library%2C+NYC%2C+USA%2C+North+America.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Informative+tour+around+Morgan+Library%2C+NYC%2C+USA%2C+North+America.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 992,
               
                "name": "Life and Death at the Mexican Border Documentary",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Life+and+Death+at+the+Mexican+Border+Documentary.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Life+and+Death+at+the+Mexican+Border+Documentary.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 993,
               
                "name": "Mountain climbers crossing ice faults, Mount Everest, Himalayas, Asia",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Mountain+climbers+crossing+ice+faults%2C+Mount+Everest%2C+Himalayas%2C+Asia.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Mountain+climbers+crossing+ice+faults%2C+Mount+Everest%2C+Himalayas%2C+Asia.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 994,
                "name": "Surfing the cold river wave in winter",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Surfing+the+cold+river+wave+in+winter.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Surfing+the+cold+river+wave+in+winter.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 995,
                "name": "Tour Madrid - Spanish Guide",
                "duration": "Watch 3D",
                "videoUrl": "https://cdn.mobio360.com/vrdocumentary/Tour+Madrid+-+Spanish+Guide.mp4",
                "preview": "https://cdn.mobio360.com/vrdocumentary/Tour+Madrid+-+Spanish+Guide.jpg",
                "filename": "",
                "desc": ""
              },
        ]
    },
]


// WEBPACK FOOTER //
// ./src/constants/videos360.js